const colorButtons = document.querySelectorAll(".color-card");
const sizeInputs = document.querySelectorAll('input[name="size"]');
const selectedImage = document.querySelector("#selectedImage");
const selectedName = document.querySelector("#selectedName");
const selectedDesc = document.querySelector("#selectedDesc");
const panelQuantity = document.querySelector("#panelQuantity");
const addToCart = document.querySelector("#addToCart");
const cartCount = document.querySelector("#cartCount");
const cartItems = document.querySelector("#cartItems");
const orderSubtotal = document.querySelector("#orderSubtotal");
const orderTotal = document.querySelector("#orderTotal");
const discountLines = document.querySelector("#discountLines");
const orderForm = document.querySelector("#orderForm");
const orderConfirmation = document.querySelector("#orderConfirmation");
const reminderConsent = document.querySelector("#reminderConsent");
const proStaffForm = document.querySelector("#proStaffForm");
const proStaffConfirmation = document.querySelector("#proStaffConfirmation");
const contactForm = document.querySelector("#contactForm");
const contactConfirmation = document.querySelector("#contactConfirmation");
const accountLoginForm = document.querySelector("#accountLoginForm");
const accountName = document.querySelector("#accountName");
const accountPerks = document.querySelector("#accountPerks");
const accountBadges = document.querySelector("#accountBadges");
const historyList = document.querySelector("#historyList");
const catchSubmitForm = document.querySelector("#catchSubmitForm");
const catchConfirmation = document.querySelector("#catchConfirmation");
const signupForm = document.querySelector("#signupForm");
const signupConfirmation = document.querySelector("#signupConfirmation");
const addStarterPack = document.querySelector("#addStarterPack");
const starterPackSize = document.querySelector("#starterPackSize");
const bundleButtons = document.querySelectorAll(".bundle-add-button");
const bundleSizeSelects = document.querySelectorAll(".bundle-size-select");
const reviewForm = document.querySelector("#reviewForm");
const reviewConfirmation = document.querySelector("#reviewConfirmation");
const affiliateForm = document.querySelector("#affiliateForm");
const affiliateConfirmation = document.querySelector("#affiliateConfirmation");
const wholesaleForm = document.querySelector("#wholesaleForm");
const wholesaleConfirmation = document.querySelector("#wholesaleConfirmation");
const shopifyConfigEndpoint = "/shopify-config";
const supportEmail = "joshpramey@gmail.com";
const cartKey = "candy_factory_cart";
const accountKey = "candy_factory_account";
const analyticsKey = "candy_factory_analytics_events";
const abandonedLeadKey = "candy_factory_abandoned_cart_lead";
const proStaffKey = "candy_factory_pro_staff_applications";
const contactKey = "candy_factory_customer_messages";
const signupKey = "candy_factory_signup_leads";
const reviewKey = "candy_factory_photo_reviews";
const affiliateKey = "candy_factory_referral_requests";
const wholesaleKey = "candy_factory_wholesale_requests";

function assetUrl(fileName) {
  return window.CandyFactoryAssets?.[fileName] || fileName;
}

const products = {
  jawbreaker: {
    id: "jawbreaker",
    name: "The Jawbreaker",
    category: "Skirted Wobble Head Jig",
    price: 6,
    fallbackImage: assetUrl("okeechobee-craw.png"),
    sizes: ["1/4 oz", "3/8 oz", "1/2 oz"],
  },
  "dirty-water-pack": {
    id: "dirty-water-pack",
    name: "Dirty Water Pack",
    category: "Jawbreaker Bundle",
    price: 24,
    fallbackImage: assetUrl("black-blue.png"),
    sizes: ["1/4 oz", "3/8 oz", "1/2 oz"],
  },
  "craw-color-pack": {
    id: "craw-color-pack",
    name: "Craw Color Pack",
    category: "Jawbreaker Bundle",
    price: 24,
    fallbackImage: assetUrl("color-lineup.png"),
    sizes: ["1/4 oz", "3/8 oz", "1/2 oz"],
  },
  "starter-kit": {
    id: "starter-kit",
    name: "Starter Jawbreaker Kit",
    category: "Jawbreaker Bundle",
    price: 30,
    fallbackImage: assetUrl("color-lineup.png"),
    sizes: ["1/4 oz", "3/8 oz", "1/2 oz"],
  },
  "pro-staff-starter-pack": {
    id: "pro-staff-starter-pack",
    name: "Pro Staff Pick Pack",
    category: "Jawbreaker Bundle",
    price: 30,
    fallbackImage: assetUrl("proven-water.jpg"),
    sizes: ["1/4 oz", "3/8 oz", "1/2 oz"],
  },
};

let currentColor = "Okeechobee Craw";
let currentSize = "1/4 oz";
let currentProductId = "jawbreaker";
let account = loadAccount();

const colors = Array.from(colorButtons).map((button) => ({
  name: button.dataset.name,
  image: button.dataset.image,
  desc: button.dataset.desc,
}));

let cart = loadCart();
let shopifyConfig = {
  shopifyDomain: "",
  storefrontToken: "",
  siteUrl: "",
  configured: false,
};

function formatCurrency(value) {
  return `$${value.toFixed(2)}`;
}

function track(eventName, detail = {}) {
  const events = JSON.parse(localStorage.getItem(analyticsKey) || "[]");
  events.push({
    eventName,
    detail,
    timestamp: new Date().toISOString(),
  });
  localStorage.setItem(analyticsKey, JSON.stringify(events.slice(-50)));
}

function getShopifyVariantData() {
  const dataEl = document.querySelector("#CandyFactoryVariantMap");
  if (!dataEl) return null;

  try {
    return JSON.parse(dataEl.textContent || "{}");
  } catch {
    return null;
  }
}

function findShopifyVariantId(color, size) {
  const data = getShopifyVariantData();
  const variant = data?.variants?.find((item) => item.color === color && item.size === size && item.available);
  return variant?.id;
}

async function addShopifyItems(items) {
  const validItems = items.filter((item) => item.id && item.quantity > 0);
  if (validItems.length !== items.length) {
    alert("This bundle is not available in the selected size yet.");
    return false;
  }

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: validItems }),
  });

  if (!response.ok) {
    alert("We could not add that bundle to the cart. Please try a different size or color.");
    return false;
  }

  window.location.href = "/cart";
  return true;
}

function openEmail(subject, lines) {
  const body = lines.filter(Boolean).join("\n");
  const mailto = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailto;
}

async function loadShopifyConfig() {
  try {
    const response = await fetch(shopifyConfigEndpoint, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) return;
    shopifyConfig = await response.json();
    track("shopify_config_loaded", { configured: Boolean(shopifyConfig.configured) });
  } catch {
    shopifyConfig = { ...shopifyConfig, configured: false };
  }
}

function loadCart() {
  try {
    const saved = JSON.parse(localStorage.getItem(cartKey) || "[]");
    return saved
      .map((item) => {
        const product = products[item.productId] || products.jawbreaker;
        const color = getColor(item.color);
        return {
          id: item.id || `${product.id}-${item.color || currentColor}-${item.size || currentSize}`,
          productId: item.productId || product.id,
          productName: item.productName || product.name,
          color: item.color || currentColor,
          size: item.size || currentSize,
          quantity: Math.max(1, Number(item.quantity) || 1),
          unitPrice: Number(item.unitPrice) || product.price,
          image: item.image || color?.image || product.fallbackImage,
        };
      })
      .filter((item) => item.productId && item.quantity > 0);
  } catch {
    return [];
  }
}

function saveCart() {
  localStorage.setItem(cartKey, JSON.stringify(cart));
}

function getColor(name) {
  return colors.find((item) => item.name === name);
}

function getCartQuantity() {
  return cart.reduce((total, item) => total + item.quantity, 0);
}

function getCartTotal() {
  return cart.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
}

function getDiscountAmount(subtotal) {
  return account.role === "pro-staff" ? subtotal * 0.1 : 0;
}

function getGrandTotal() {
  const subtotal = getCartTotal();
  return Math.max(0, subtotal - getDiscountAmount(subtotal));
}

function renderCart() {
  if (!cartCount || !cartItems || !orderSubtotal || !orderTotal || !discountLines) return;

  const subtotal = getCartTotal();
  const discount = getDiscountAmount(subtotal);
  cartCount.textContent = getCartQuantity();
  orderSubtotal.textContent = formatCurrency(subtotal);
  orderTotal.textContent = formatCurrency(getGrandTotal());
  discountLines.innerHTML =
    account.role === "pro-staff"
      ? `
        <div class="discount-line"><span>Pro Staff discount</span><strong>-${formatCurrency(discount)}</strong></div>
        <div class="discount-line"><span>Shipping</span><strong>Free</strong></div>
      `
      : '<div class="discount-line"><span>Shipping</span><strong>Calculated after order review</strong></div>';

  if (cart.length === 0) {
    cartItems.innerHTML = '<p class="cart-empty">Your cart is empty. Pick a color above and add it here.</p>';
    return;
  }

  cartItems.innerHTML = cart
    .map((item) => {
      const color = getColor(item.color);
      const product = products[item.productId] || products.jawbreaker;
      return `
        <div class="cart-item" data-id="${item.id}">
          <img src="${item.image || color?.image || product.fallbackImage}" alt="${item.color} ${product.name}">
          <div>
            <h4>${item.productName || product.name}</h4>
            <p>${item.color} / ${item.size} / ${formatCurrency(item.unitPrice)} each</p>
            <div class="cart-controls">
              <input class="cart-quantity" type="number" min="1" value="${item.quantity}" aria-label="${item.productName || product.name} quantity">
              <button class="remove-item" type="button">Remove</button>
            </div>
          </div>
        </div>
      `;
    })
    .join("");
}

function setColor(name) {
  const color = getColor(name);
  if (!color || !selectedImage || !selectedName || !selectedDesc) return;

  currentColor = color.name;
  selectedImage.src = color.image;
  selectedImage.alt = `${color.name} Jawbreaker color`;
  selectedName.textContent = color.name;
  selectedDesc.textContent = color.desc;

  colorButtons.forEach((button) => {
    button.classList.toggle("active", button.dataset.name === color.name);
  });
}

function setSize(size) {
  currentSize = size;
  sizeInputs.forEach((input) => {
    input.checked = input.value === size;
  });
}

function addCurrentToCart() {
  const product = products[currentProductId];
  const color = getColor(currentColor);
  if (!product || !panelQuantity) return;

  const quantity = Math.max(1, Number(panelQuantity.value) || 1);
  panelQuantity.value = quantity;
  const id = `${product.id}-${currentColor}-${currentSize}`;
  const existing = cart.find((item) => item.id === id);

  if (existing) {
    existing.quantity += quantity;
  } else {
    cart.push({
      id,
      productId: product.id,
      productName: product.name,
      color: currentColor,
      size: currentSize,
      quantity,
      unitPrice: product.price,
      image: color?.image || product.fallbackImage,
    });
  }

  saveCart();
  renderCart();
  track("add_to_cart", { productId: product.id, productName: product.name, color: currentColor, size: currentSize, quantity });
  location.hash = "order";
}

function updateCartItem(id, quantity) {
  cart = cart
    .map((item) => (item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item))
    .filter((item) => item.quantity > 0);
  saveCart();
  renderCart();
  track("cart_updated", { id, quantity });
}

function removeCartItem(id) {
  cart = cart.filter((item) => item.id !== id);
  saveCart();
  renderCart();
  track("remove_from_cart", { id });
}

function loadAccount() {
  try {
    return JSON.parse(localStorage.getItem(accountKey) || '{"email":"","role":"guest"}');
  } catch {
    return { email: "", role: "guest" };
  }
}

function saveAccount() {
  localStorage.setItem(accountKey, JSON.stringify(account));
}

function renderAccount() {
  if (!accountName || !accountPerks || !accountBadges) return;

  if (account.role === "pro-staff") {
    accountName.textContent = "Approved Pro Staff";
    accountPerks.textContent = `${account.email} gets 10% off, free shipping, reorder tools, and catch photo submission.`;
    accountBadges.innerHTML = "<span>10% off</span><span>Free shipping</span><span>Catch photos</span>";
    return;
  }

  if (account.role === "customer") {
    accountName.textContent = "Customer account";
    accountPerks.textContent = `${account.email} can view previous orders and reorder quickly.`;
    accountBadges.innerHTML = "<span>Order history</span><span>Fast reorder</span>";
    return;
  }

  accountName.textContent = "Guest customer";
  accountPerks.textContent = "Sign in to preview customer order history and Pro Staff benefits.";
  accountBadges.innerHTML = "<span>Retail pricing</span>";
}

function addConfiguredProductToCart(productId, colorName, size, quantity) {
  const product = products[productId] || products.jawbreaker;
  const color = getColor(colorName);
  const id = `${product.id}-${colorName}-${size}`;
  const existing = cart.find((item) => item.id === id);

  if (existing) {
    existing.quantity += quantity;
  } else {
    cart.push({
      id,
      productId: product.id,
      productName: product.name,
      color: colorName,
      size,
      quantity,
      unitPrice: product.price,
      image: color?.image || product.fallbackImage,
    });
  }

  saveCart();
  renderCart();
}

function getBundleSize(productId) {
  const select = Array.from(bundleSizeSelects).find((item) => item.dataset.productId === productId);
  return select?.value || "3/8 oz";
}

async function addBundleToCart(productId, size = "3/8 oz") {
  const shopifyVariantData = getShopifyVariantData();
  const bundleColors = shopifyVariantData?.bundles?.[productId];

  if (bundleColors?.length) {
    const items = bundleColors.map((color) => ({
      id: findShopifyVariantId(color, size),
      quantity: 1,
    }));
    track("add_to_cart", { productId, productName: products[productId]?.name, color: "Bundle", size, quantity: items.length });
    await addShopifyItems(items);
    return;
  }

  const product = products[productId];
  if (!product) return;

  addConfiguredProductToCart(product.id, "Assorted Colors", size, 1);
  track("add_to_cart", {
    productId: product.id,
    productName: product.name,
    color: "Assorted Colors",
    size,
    quantity: 1,
  });
  location.hash = "order";
}

colorButtons.forEach((button) => {
  button.addEventListener("click", () => setColor(button.dataset.name));
});

sizeInputs.forEach((input) => {
  input.addEventListener("change", () => setSize(input.value));
});

if (addToCart && addToCart.tagName === "BUTTON") {
  addToCart.addEventListener("click", addCurrentToCart);
}

if (cartItems) {
  cartItems.addEventListener("input", (event) => {
    if (!event.target.classList.contains("cart-quantity")) return;
    const item = event.target.closest(".cart-item");
    if (!item) return;
    updateCartItem(item.dataset.id, Number(event.target.value) || 1);
  });

  cartItems.addEventListener("click", (event) => {
    if (!event.target.classList.contains("remove-item")) return;
    const item = event.target.closest(".cart-item");
    if (!item) return;
    removeCartItem(item.dataset.id);
  });
}

if (orderForm) {
  orderForm.addEventListener("input", () => {
    const form = new FormData(orderForm);
    const contact = String(form.get("contact") || "").trim();
    if (contact && reminderConsent?.checked && cart.length > 0) {
      localStorage.setItem(
        abandonedLeadKey,
        JSON.stringify({
          contact,
          cart,
          updatedAt: new Date().toISOString(),
        }),
      );
      track("abandoned_cart_lead_saved", { itemCount: getCartQuantity() });
    }
  });

  orderForm.addEventListener("submit", (event) => {
    event.preventDefault();
    const form = new FormData(orderForm);

    if (cart.length === 0) {
      if (orderConfirmation) {
        orderConfirmation.hidden = false;
        orderConfirmation.textContent = "Add at least one Jawbreaker to the cart before placing the order.";
      }
      return;
    }

    const order = {
      items: cart,
      subtotal: getCartTotal(),
      discount: getDiscountAmount(getCartTotal()),
      total: getGrandTotal(),
      accountRole: account.role,
      customer: {
        name: String(form.get("name") || "").trim(),
        contact: String(form.get("contact") || "").trim(),
        zip: String(form.get("zip") || "").trim(),
        reminderConsent: Boolean(reminderConsent?.checked),
        notes: String(form.get("notes") || "").trim(),
      },
      createdAt: new Date().toISOString(),
    };

    localStorage.setItem("candy_factory_last_order", JSON.stringify(order));
    track("checkout_submitted", { itemCount: getCartQuantity(), total: order.total });
    cart = [];
    saveCart();
    renderCart();

    if (orderConfirmation) {
      orderConfirmation.hidden = false;
      orderConfirmation.textContent = `Order placed for ${formatCurrency(order.total)}. Customer details are ready to send to your order system.`;
      orderConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  });
}

if (accountLoginForm) {
  accountLoginForm.addEventListener("submit", (event) => {
    event.preventDefault();
    const form = new FormData(accountLoginForm);
    account = {
      email: String(form.get("email") || "").trim(),
      role: String(form.get("role") || "customer"),
      signedInAt: new Date().toISOString(),
    };
    saveAccount();
    renderAccount();
    renderCart();
    track("account_preview_login", { role: account.role });
  });
}

if (historyList) {
  historyList.addEventListener("click", (event) => {
    const button = event.target.closest(".reorder-button");
    if (!button) return;
    addConfiguredProductToCart(
      button.dataset.productId,
      button.dataset.color,
      button.dataset.size,
      Number(button.dataset.quantity) || 1,
    );
    track("reorder_clicked", {
      productId: button.dataset.productId,
      color: button.dataset.color,
      size: button.dataset.size,
    });
    location.hash = "order";
  });
}

if (addStarterPack) {
  addStarterPack.addEventListener("click", () => addBundleToCart("pro-staff-starter-pack", starterPackSize?.value || "3/8 oz"));
}

bundleButtons.forEach((button) => {
  button.addEventListener("click", () => addBundleToCart(button.dataset.productId, getBundleSize(button.dataset.productId)));
});

if (proStaffForm) {
  proStaffForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(proStaffForm);
  const application = {
    name: String(form.get("name") || "").trim(),
    email: String(form.get("email") || "").trim(),
    phone: String(form.get("phone") || "").trim(),
    region: String(form.get("region") || "").trim(),
    social: String(form.get("social") || "").trim(),
    style: String(form.get("style") || "").trim(),
    reason: String(form.get("reason") || "").trim(),
    photoNotes: String(form.get("photoNotes") || "").trim(),
    featureConsent: form.get("featureConsent") === "on",
    starterPurchaseConsent: form.get("starterPurchaseConsent") === "on",
    submittedAt: new Date().toISOString(),
  };
  const applications = JSON.parse(localStorage.getItem(proStaffKey) || "[]");
  applications.push(application);
  localStorage.setItem(proStaffKey, JSON.stringify(applications.slice(-100)));
  track("pro_staff_application_submitted", {
    region: application.region,
    style: application.style,
  });

  proStaffConfirmation.hidden = false;
  proStaffConfirmation.textContent = "Application prepared for email to Josh. If your email app opened, send it to finish submitting.";
  proStaffConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail("Pro Staff Application - The Candy Factory Bait Co.", [
    "New Pro Staff application",
    "",
    `Name: ${application.name}`,
    `Email: ${application.email}`,
    `Phone: ${application.phone}`,
    `Home lake / region: ${application.region}`,
    `Social profile: ${application.social}`,
    `Fishing style: ${application.style}`,
    "",
    "Why they want to join:",
    application.reason,
    "",
    "Catch photo link or upload notes:",
    application.photoNotes,
    "",
    `Feature consent: ${application.featureConsent ? "Yes" : "No"}`,
    `Understands $25+ initial purchase requirement: ${application.starterPurchaseConsent ? "Yes" : "No"}`,
    `Submitted: ${application.submittedAt}`,
  ]);
  proStaffForm.reset();
  });
}

if (contactForm) {
  contactForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(contactForm);
  const message = {
    name: String(form.get("name") || "").trim(),
    email: String(form.get("email") || "").trim(),
    topic: String(form.get("topic") || "").trim(),
    message: String(form.get("message") || "").trim(),
    submittedAt: new Date().toISOString(),
  };
  const messages = JSON.parse(localStorage.getItem(contactKey) || "[]");
  messages.push(message);
  localStorage.setItem(contactKey, JSON.stringify(messages.slice(-100)));
  track("customer_service_message_submitted", { topic: message.topic });

  contactConfirmation.hidden = false;
  contactConfirmation.textContent = "Message prepared for email to Josh. If your email app opened, send it to finish submitting.";
  contactConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail(`Customer Service - ${message.topic}`, [
    "Customer service message",
    "",
    `Name: ${message.name}`,
    `Email: ${message.email}`,
    `Topic: ${message.topic}`,
    "",
    "Message:",
    message.message,
    "",
    `Submitted: ${message.submittedAt}`,
  ]);
  contactForm.reset();
  });
}

if (catchSubmitForm) {
  catchSubmitForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(catchSubmitForm);
  const catchSubmission = {
    accountEmail: account.email || "Not signed in",
    product: String(form.get("product") || "").trim(),
    color: String(form.get("color") || "").trim(),
    fish: String(form.get("fish") || "").trim(),
    story: String(form.get("story") || "").trim(),
    submittedAt: new Date().toISOString(),
  };
  track("catch_submission_started", { product: catchSubmission.product });
  catchConfirmation.hidden = false;
  catchConfirmation.textContent = "Catch submission prepared for email to Josh. If your email app opened, send it to finish submitting.";
  catchConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail("Pro Staff Catch Submission - The Candy Factory Bait Co.", [
    "New catch photo/testimonial submission",
    "",
    `Account email: ${catchSubmission.accountEmail}`,
    `Product: ${catchSubmission.product}`,
    `Color: ${catchSubmission.color}`,
    `Fish details: ${catchSubmission.fish}`,
    "",
    "Photo link / story:",
    catchSubmission.story,
    "",
    `Submitted: ${catchSubmission.submittedAt}`,
  ]);
  catchSubmitForm.reset();
  });
}

if (signupForm) {
  signupForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(signupForm);
  const lead = {
    name: String(form.get("name") || "").trim(),
    email: String(form.get("email") || "").trim(),
    phone: String(form.get("phone") || "").trim(),
    consent: form.get("consent") === "on",
    submittedAt: new Date().toISOString(),
  };
  const leads = JSON.parse(localStorage.getItem(signupKey) || "[]");
  leads.push(lead);
  localStorage.setItem(signupKey, JSON.stringify(leads.slice(-250)));
  track("signup_submitted", { hasPhone: Boolean(lead.phone) });
  signupConfirmation.hidden = false;
  signupConfirmation.textContent = "You are on the prototype list for drops, restocks, custom colors, and fishing tips.";
  signupConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  signupForm.reset();
  });
}

if (reviewForm) {
  reviewForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(reviewForm);
  const review = {
    name: String(form.get("name") || "").trim(),
    email: String(form.get("email") || "").trim(),
    rating: String(form.get("rating") || "").trim(),
    product: String(form.get("product") || "").trim(),
    review: String(form.get("review") || "").trim(),
    submittedAt: new Date().toISOString(),
  };
  const reviews = JSON.parse(localStorage.getItem(reviewKey) || "[]");
  reviews.push(review);
  localStorage.setItem(reviewKey, JSON.stringify(reviews.slice(-150)));
  track("photo_review_submitted", { rating: review.rating, product: review.product });
  reviewConfirmation.hidden = false;
  reviewConfirmation.textContent = "Review prepared for email to Josh. If your email app opened, send it to finish submitting.";
  reviewConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail("Photo Review - The Candy Factory Bait Co.", [
    "New photo review",
    "",
    `Name: ${review.name}`,
    `Email: ${review.email}`,
    `Rating: ${review.rating}`,
    `Product / color: ${review.product}`,
    "",
    "Photo link and review:",
    review.review,
    "",
    `Submitted: ${review.submittedAt}`,
  ]);
  reviewForm.reset();
  });
}

if (affiliateForm) {
  affiliateForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(affiliateForm);
  const request = {
    name: String(form.get("name") || "").trim(),
    email: String(form.get("email") || "").trim(),
    audience: String(form.get("audience") || "").trim(),
    submittedAt: new Date().toISOString(),
  };
  const requests = JSON.parse(localStorage.getItem(affiliateKey) || "[]");
  requests.push(request);
  localStorage.setItem(affiliateKey, JSON.stringify(requests.slice(-100)));
  track("referral_request_submitted", {});
  affiliateConfirmation.hidden = false;
  affiliateConfirmation.textContent = "Referral request prepared for email to Josh. If your email app opened, send it to finish submitting.";
  affiliateConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail("Referral Program Request - The Candy Factory Bait Co.", [
    "New referral / affiliate request",
    "",
    `Name: ${request.name}`,
    `Email: ${request.email}`,
    "",
    "Audience / social links:",
    request.audience,
    "",
    `Submitted: ${request.submittedAt}`,
  ]);
  affiliateForm.reset();
  });
}

if (wholesaleForm) {
  wholesaleForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const form = new FormData(wholesaleForm);
  const request = {
    name: String(form.get("name") || "").trim(),
    business: String(form.get("business") || "").trim(),
    email: String(form.get("email") || "").trim(),
    phone: String(form.get("phone") || "").trim(),
    message: String(form.get("message") || "").trim(),
    submittedAt: new Date().toISOString(),
  };
  const requests = JSON.parse(localStorage.getItem(wholesaleKey) || "[]");
  requests.push(request);
  localStorage.setItem(wholesaleKey, JSON.stringify(requests.slice(-100)));
  track("wholesale_request_submitted", {});
  wholesaleConfirmation.hidden = false;
  wholesaleConfirmation.textContent = "Wholesale request prepared for email to Josh. If your email app opened, send it to finish submitting.";
  wholesaleConfirmation.scrollIntoView({ behavior: "smooth", block: "nearest" });
  openEmail("Wholesale Request - The Candy Factory Bait Co.", [
    "New wholesale / retail request",
    "",
    `Name: ${request.name}`,
    `Business / organization: ${request.business}`,
    `Email: ${request.email}`,
    `Phone: ${request.phone}`,
    "",
    "Request:",
    request.message,
    "",
    `Submitted: ${request.submittedAt}`,
  ]);
  wholesaleForm.reset();
  });
}

setColor(currentColor);
setSize(currentSize);
renderAccount();
renderCart();
track("page_view", { page: location.pathname || "/" });
loadShopifyConfig();
